import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState, phoneRegex } from '@opu/utils';
import { useHistory, useLocation } from 'react-router-dom';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';

const useForm = () => {
  let history = useHistory();
  let location = useLocation();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location.params && location.params.id) {
      getOpuUser();
    } else {
      history.push('/opu-user');
    }
  }, []);

  const back = () => {
    history.goBack();
  };

  const getOpuUser = () => {
    AxiosInstance.get('/opu-user/' + location.params.id)
      .then((response) => {
        let inputValues = {
          firstName: response.data.user.firstName,
          lastName: response.data.user.lastName,
          email: response.data.user.email,
          gender: response.data.user.gender,
          phone: response.data.user.phone,
          role: response.data.role,
        };
        updateFormState(inputValues);
      })
      .catch((error) => {
        Swal.fire(t('opu-user.ERROR_GET_OPU_USER'), '', 'error');
        history.push('/opu-user');
      });
  };

  const updateOpuUser = () => {
    setLoading(true);
    AxiosInstance.patch('/opu-user/' + location.params.id, {
      firstName: formState.inputValues.firstName,
      lastName: formState.inputValues.lastName,
      gender: formState.inputValues.gender,
      email: formState.inputValues.email,
      phone: formState.inputValues.phone,
      role: formState.inputValues.role,
    })
      .then((res) => {
        Swal.fire(t('opu-user.SUCCESS_UPDATE_OPU_USER'), '', 'success');
        setLoading(false);
      })
      .catch((error) => {
        Swal.fire(t('opu-user.ERROR_UPDATE_OPU_USER'), '', 'error');
        setLoading(false);
      });
  };

  const inputValues = {
    firstName: { value: '', validate: { required: true } },
    lastName: { value: '', validate: { required: true } },
    email: { value: '', validate: { required: true, pattern: emailRegex } },
    phone: { value: '', validate: { required: true, pattern: phoneRegex } },
    gender: { value: '', validate: { required: true } },
    role: { value: '', validate: { required: true } },
  };

  const { formState, submitHandler, updateFormState, field } = FormState(inputValues, updateOpuUser);

  return {
    submitHandler,
    back,
    loading,
    field,
  };
};

export default useForm;
